import React from "react";
import { Container } from "react-bootstrap";

import "./Partners.scss";
import p1 from "../../../../assets/images/p1.png";
import p2 from "../../../../assets/images/p2.png";
import p3 from "../../../../assets/images/p3.png";
import p4 from "../../../../assets/images/p4.png";
import p5 from "../../../../assets/images/p5.png";
import p6 from "../../../../assets/images/p6.png";
import p7 from "../../../../assets/images/p7.png";
import p8 from "../../../../assets/images/p8.png";
import p9 from "../../../../assets/images/p9.png";
import p10 from "../../../../assets/images/p10.png";
import p11 from "../../../../assets/images/p11.png";
import p12 from "../../../../assets/images/p12.png";
import p13 from "../../../../assets/images/p13.png";
import p14 from "../../../../assets/images/p14.png";

const Partners = () => {
  const list = [p1, p2, p3, p4, p5, p7, p8, p9, p10, p11, p12, p13, p6, p14];

  return (
    <div className="partners">
      <Container className="logos">
        <div className="logos-slide">
          {list.map((item, i) => (
            <img src={item} alt={`partners-${i}`} key={i} />
          ))}
        </div>
        <div className="logos-slide">
          {list.map((item, i) => (
            <img src={item} alt={`partners-${i}`} key={i} />
          ))}
        </div>
      </Container>
    </div>
  );
};

export default Partners;
